import type { Cita } from '../types';

export interface DiaCalendario {
  fecha: Date;
  esOtroMes: boolean;
}

export function esCitaPasada(fecha: string, hora: string): boolean {
  return new Date(fecha + ' ' + hora) < new Date();
}

export function ordenarCitasPorFechaHora(citas: Cita[]): Cita[] {
  return [...citas].sort(
    (a, b) =>
      new Date(a.fecha + ' ' + a.hora).getTime() - new Date(b.fecha + ' ' + b.hora).getTime()
  );
}

export function obtenerCitasDelDia(citas: Cita[], fecha: Date): Cita[] {
  const fechaStr = fecha.toISOString().split('T')[0];
  return citas.filter((c) => c.fecha === fechaStr);
}

export function obtenerDiasDelMes(fecha: Date): DiaCalendario[] {
  const year = fecha.getFullYear();
  const month = fecha.getMonth();
  const primerDia = new Date(year, month, 1);
  const ultimoDia = new Date(year, month + 1, 0);
  const diasAntes = primerDia.getDay();
  const diasMes = ultimoDia.getDate();

  const dias: DiaCalendario[] = [];

  for (let i = diasAntes - 1; i >= 0; i--) {
    dias.push({ fecha: new Date(year, month, -i), esOtroMes: true });
  }
  for (let i = 1; i <= diasMes; i++) {
    dias.push({ fecha: new Date(year, month, i), esOtroMes: false });
  }
  const diasRestantes = 42 - dias.length;
  for (let i = 1; i <= diasRestantes; i++) {
    dias.push({ fecha: new Date(year, month + 1, i), esOtroMes: true });
  }

  return dias;
}
